export const HWB_WELL_BEING_COACHING_SERVICE_TYPE = 'HWB - Well-Being Coaching';

export const isEapServiceType = (serviceType: string | undefined | null): boolean =>
  (serviceType || '').trim().toUpperCase() === 'EAP';

export const isHwbWellBeingCoachingServiceType = (serviceType: string | undefined | null): boolean =>
  (serviceType || '').trim() === HWB_WELL_BEING_COACHING_SERVICE_TYPE;
